export enum WebhookStatus {
  Active = 'active',
  Paused = 'paused',
}

export interface WebhookDto {
  id?: string;
  name?: string;
  endpointUrl?: string;
  eventTypes?: string[];
  filters?: string[];
  status?: WebhookStatus;
  maxAttempts?: number;
  timeoutSeconds?: number;
  lastDeliveryAt?: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
}
